var VCA = VCA || {};

VCA.dropDownFilters = (function ($) {

    var ui = {};

    function cacheUI() {
        ui.$dropDownInput = $('.js-referral-card-input');
        ui.$filterList = $('.js-referral-list');
        ui.$filterListitems = $('.referral-cards__item');
        ui.$listCTA = $('.referral-cards__item__cta');
    }

    function init() {
        if ($('.js-referral-card-input').length <= 0) {
            return;
        }
        cacheUI();
        bindFilterChange();
    }

    function bindFilterChange() {
        ui.$dropDownInput.on('change', function (e) {
            e.preventDefault();
            filterValue = $(this).val();
            console.log(filterValue);
            if(filterValue == 'all') {
                ui.$filterList.find('.referral-cards__item').fadeOut().promise().done(function () {
                    ui.$filterList.find('.referral-cards__item').fadeIn();
                });
            }else {
                ui.$filterList.find('.referral-cards__item').fadeOut().promise().done(function () {
                    ui.$filterList.find('[data-value="' + filterValue +'"]').fadeIn();
                    ui.$listCTA.fadeIn();
                });
            }
        });
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.dropDownFilters.init();
});